import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
import qs from 'qs'

let baseUrl = 'https://xc-os-api.din-job.com';
// let baseUrl = 'https://ddlg-web.din-job.com';
// let baseUrl = 'http://192.168.1.124:8080'
// let baseUrl = 'http:// 192.168.1.135:8082';
// let baseUrl = process.env.VUE_APP_BASE_API || 'https://msz-api.ynoudun.com';

// 创建axios实例
let service = axios.create({
	baseURL: baseUrl, // api的base_url
	timeout: 5000 // 请求超时时间
});
let messageCount = 0;
// request拦截器
service.interceptors.request.use(config => {
	return config
}, error => {
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
		const res = response.data
		if(res.code == 200){
			return response.data
		} else{
			Message({message: res.msg,type: 'error', duration: 5 * 1000})
			return Promise.reject('error')
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)



const defaultErrorCallback = (error) => {
}

export const serverData = {
	baseUrl
}

export const getJson = (url, params, callback = () => {}, errcallback = defaultErrorCallback) => {
	// params.token = '63e60192db40f6356d07a701';
	service.request({
		url,
		method: 'get',
		params
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const postJson = (url, data = {}, callback = () => {}) => {
	service.request({
		url,
		method: 'post',
		data
	}).then(res => {
		callback(res)
	})
}

export const postForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	if(timeUrl){ baseUrl = timeUrl }
	service.request({
		headers: {'Content-Type': 'application/x-www-form-urlencoded',},
		url,
		method: 'post',
		data
	}).then(res => {
		baseUrl = timeBaseUrl;
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const putForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		url,
		method: 'put',
		data: qs.stringify(data)
	}).then(res => {
		// console.log('then', res)
		callback(res)
	}).catch(res => {
		// console.log('catch', res)
		errcallback(res)
	})
}

export const patchForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		url,
		method: 'patch',
		data: qs.stringify(data)
	}).then(res => {
		// console.log('then', res)
		callback(res)
	}).catch(res => {
		// console.log('catch', res)
		errcallback(res)
	})
}

export const deleteJson = (url, params, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		url,
		method: 'delete',
		params
	}).then(res => {
		callback(res)
	}).catch(res => {
		// console.log('catch', res)
		errcallback(res)
	})
}

export const deleteJsonSYNC = (url, params) => {
	return service.request({
		url,
		method: 'delete',
		params
	})
}

export default service
